import * as React from "react";
import type { SVGProps } from "react";
const SvgIconGoogleDrive = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 76 75"
    {...props}
  >
    <path
      fill="#34A853"
      d="M37.71 26.995 27.475 8.932a3.2 3.2 0 0 1 1.122-.726c-3.019.993-4.403 4.383-4.403 4.383L5.495 45.579a9.7 9.7 0 0 0-.303 2.79H25.6z"
    />
    <path
      fill="#FBBC05"
      d="m37.71 26.995 12.11 21.374H70.23a9.7 9.7 0 0 0-.304-2.79l-18.698-32.99s-1.389-3.39-4.403-4.383c.387.153.782.38 1.122.726z"
    />
    <path
      fill="#188038"
      d="M37.71 26.996 47.946 8.933a3.2 3.2 0 0 0-1.122-.726 5.5 5.5 0 0 0-1.444-.268H30.041c-.516.023-.998.12-1.444.268-.388.153-.782.38-1.122.726z"
    />
    <path
      fill="#4285F4"
      d="M25.604 48.37 15.486 66.227s-.337-.164-.793-.503c1.436 1.105 2.832 1.34 2.832 1.34h39.739c2.192 0 2.65-.837 2.65-.837q.008-.006.017-.011l-10.11-17.848z"
    />
    <path
      fill="#1967D2"
      d="M25.605 48.37H5.196c.103 2.425 1.155 3.842 1.155 3.842l.767 1.332c.055.079.088.123.088.123l1.67 2.932 3.75 6.526c.109.264.237.506.372.736.051.079.099.164.153.239l.044.067c.464.654.983 1.16 1.502 1.558.457.343.793.503.793.503z"
    />
    <path
      fill="#EA4335"
      d="M49.82 48.37H70.23c-.103 2.425-1.155 3.842-1.155 3.842l-.767 1.332c-.055.079-.088.123-.088.123l-1.67 2.932-3.75 6.526c-.109.264-.237.506-.372.736-.051.079-.099.164-.153.239l-.044.067a7.2 7.2 0 0 1-1.502 1.558c-.457.343-.793.503-.793.503z"
    />
  </svg>
);
export default SvgIconGoogleDrive;
